import { defineStore } from 'pinia'
import { nextTick, ref, watch } from 'vue'
import { useAppContext } from '@/stores/appContext'
import { useDynamicFormCultureStore } from '@/stores/DynamicFormCultureStore'
type VcLanguage = any;
const messageModules=import.meta.glob("./vc/*.mjs")
const overrideMessagesCache: Record<string, Record<string, string>> = {}
export const useVcLocale = defineStore("vcLocale", () => {
  const appContext = useAppContext();
  const localizationMap = new Map<string, VcLanguage>();
  const locale = ref<VcLanguage>();
  const loadLocaleMessages = async (localeName: string) => {
    localeName = localeName.toLowerCase();
    if (localizationMap.has(localeName)) {
      locale.value = localizationMap.get(localeName);
      return nextTick();
    }
    try {
      const importMethod=messageModules[`./vc/${localeName}.mjs`];
      if(!importMethod) {
        return;
      }
      const messageModule:any=await importMethod();
      const messages = messageModule?.default;
      const backEnd = await getCulture(localeName);
      const overrideLocaleMessages = await loadOverrideMessages(localeName)
      messages.vc = {
        ...messages.vc,
        ...backEnd,
        ...overrideLocaleMessages
      }
      locale.value = messages;
      localizationMap.set(localeName, messages);
      return nextTick()
    }
    catch (error: any) {
      if (import.meta.env.DEV) {
        localizationMap.set(localeName, { name: localeName, vc: {} });
        locale.value = localizationMap.get(localeName);
      }
      console.error(error)
    }
  }
  async function getCulture(localeName:string){
    const cultureStore = useDynamicFormCultureStore();
    return await cultureStore.getCulture(localeName);
  }
  async function loadOverrideMessages(localeName: string): Promise<Record<string, string>> {
    if (overrideMessagesCache[localeName]) {
      return overrideMessagesCache[localeName]
    }
    try {
      const isDev = import.meta.env.DEV
      const basePath = isDev ? '/src/locales/custom' : '/locales/custom'
      const response = await fetch(`${basePath}/custom.${localeName}.json?t=${Date.now()}`)
      if (response.ok) {
        const data = await response.json()
        overrideMessagesCache[localeName] = data
        return data
      }
    } catch (error) {
      console.warn(`[i18n] Failed to load custom locale file for ${localeName}:`, error)
    }
    overrideMessagesCache[localeName] = {}
    return {}
  }
  watch(() => appContext.locale, async () => {
    await loadLocaleMessages(appContext.locale);
  }, { immediate: true });
  return {
    localizationMap,
    locale
  }
});